import styled from 'styled-components'


export const PageContainer = styled.div`
    position: relative;
    width: 100%;
    min-height: 100%;
    padding-bottom: 400px;
`

